export const PAIRING_CODE_PATTERN = /^[A-Z0-9]{4}-[A-Z0-9]{4}$/;

const LOOKS_LIKE_URL = /^[a-z][a-z0-9+.-]*:\/\//i;

export function compactPairingCode(value: string) {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 8);
}

export function formatPairingCode(value: string) {
  const compact = compactPairingCode(value);
  if (compact.length <= 4) return compact;
  return `${compact.slice(0, 4)}-${compact.slice(4)}`;
}

export function pairingCodeFromInput(value: string) {
  if (LOOKS_LIKE_URL.test(value.trim())) {
    return extractPairingCode(value) ?? '';
  }
  return formatPairingCode(value);
}

export function pairingCodeFromPaste(value: string) {
  const extracted = extractPairingCode(value);
  if (extracted) return extracted;
  return LOOKS_LIKE_URL.test(value.trim()) ? '' : undefined;
}

export function extractPairingCode(value: string): string | undefined {
  const trimmed = value.trim();
  if (LOOKS_LIKE_URL.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      const path = url.pathname.replace(/\/$/, '') || '/';
      if (path !== '/connect' && path !== '/device') return undefined;
      const fromQuery = url.searchParams.get('code');
      if (!fromQuery) return undefined;
      const formatted = formatPairingCode(fromQuery);
      return PAIRING_CODE_PATTERN.test(formatted) ? formatted : undefined;
    } catch {
      return undefined;
    }
  }

  const formatted = formatPairingCode(trimmed);
  return PAIRING_CODE_PATTERN.test(formatted) ? formatted : undefined;
}
